var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrame1 = function SvgFrame1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 92.381h87.75v9.75h-87.75v-9.75Zm39-77.756h9.75V87.75h-9.75V14.625Z",
    fill: "#8AA1ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M63.375 29.25h9.75v58.5h-9.75v-58.5Zm-19.5 0h9.75v58.5h-9.75v-58.5Z",
    fill: "#8AA1ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.125 43.875h9.75V87.75h-9.75V43.875Z",
    fill: "#8AA1ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.875 58.5h9.75v29.25h-9.75V58.5Z",
    fill: "#8AA1ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 43.875h9.75V87.75h-9.75V43.875Z",
    fill: "#8AA1ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.375 58.5h9.75v29.25h-9.75V58.5Z",
    fill: "#8AA1ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 68.25h9.75v19.5h-9.75v-19.5Zm78 0h9.75v19.5h-9.75v-19.5Z",
    fill: "#8AA1ED"
  })));
};
export default SvgFrame1;